import { render, staticRenderFns } from "./Quotation-Milestones.vue?vue&type=template&id=6b9ee5f8"
import script from "./Quotation-Milestones.vue?vue&type=script&lang=js"
export * from "./Quotation-Milestones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports